import { BaseSection } from 'components/layout/Section/BaseSection';
import { NsKey } from 'enums/NsKey';
import { InputFactory } from 'factories/InputFactory';
import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { useCallback } from 'react';
import { BankAccountsFieldArray } from 'back-office/shared/components/bank-accounts/BankAccountsFieldArray';
import {
  compagnieInputsConfig,
  CompagnieInputFieldName
} from './compagnieInputsConfig';
import { CompagnieFormFieldNames } from './CompagnieFormFieldNames';

import { GerantSection } from 'back-office/shared/components/gerant/GerantSection';
export const CompagnieLayout: React.FC = () => {
  const { t } = useDynamicTranslation([NsKey.ActorForm, NsKey.Common]);

  const renderField = useCallback((fieldName: CompagnieInputFieldName) => {
    return (
      <InputFactory config={compagnieInputsConfig} fieldName={fieldName} />
    );
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <BaseSection title={t('ACTOR_FORM.BROKER.SECTIONS.GENERAL_INFO')}>
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-2">
            {renderField(CompagnieFormFieldNames.CompanyName)}
          </div>
          <div className="col-span-1">
            {renderField(CompagnieFormFieldNames.Phone)}
          </div>
        </div>
      </BaseSection>

      {/* Pas d'ORIAS ni de RCP : la compagnie relève de l'agrément ACPR,
          pas de l'intermédiation. */}
      <BaseSection title={t('ACTOR_FORM.BROKER.SECTIONS.LEGAL_INFO')}>
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-1">
            {renderField(CompagnieFormFieldNames.RegistrationNumber)}
          </div>
          <div className="col-span-1">
            {renderField(CompagnieFormFieldNames.Capital)}
          </div>
          <div className="col-span-1">
            {renderField(CompagnieFormFieldNames.RcsCity)}
          </div>
          <div className="col-span-1">
            {renderField(CompagnieFormFieldNames.RcsNumber)}
          </div>
        </div>
      </BaseSection>

      <BaseSection title="Comptes bancaires">
        <BankAccountsFieldArray
          name={CompagnieFormFieldNames.BankAccounts}
          emptyLabel="Aucun compte pour l'instant — ils serviront de destination des reversements dans la configuration des tunnels."
          helpText="Le RIB justificatif pourra être joint après la création."
        />
      </BaseSection>

      <BaseSection title={t('COMMON.LABELS.COORDINATE')}>
        <div className="grid grid-cols-6 gap-4">
          <div className="col-span-6">
            {renderField(AddressFormFieldNames.Address)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.AdditionalAddress)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.PostalCode)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.City)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.Country)}
          </div>
        </div>
      </BaseSection>

      <BaseSection title={t('ACTOR_FORM.BROKER.SECTIONS.USER_INFO')}>
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-2">
            {renderField(CompagnieFormFieldNames.PlateformeIds)}
          </div>
          <div className="col-span-1">
            {renderField(CompagnieFormFieldNames.FirstName)}
          </div>
          <div className="col-span-1">
            {renderField(CompagnieFormFieldNames.LastName)}
          </div>
          <div className="col-span-1">
            {renderField(CompagnieFormFieldNames.Email)}
          </div>
          <div className="col-span-1">
            {renderField(CompagnieFormFieldNames.Username)}
          </div>
          <div className="col-span-1">
            {renderField(CompagnieFormFieldNames.Password)}
          </div>
        </div>
      </BaseSection>

      <GerantSection config={compagnieInputsConfig} />
    </div>
  );
};
